import React, { useMemo } from 'react';

import { LegacyTextList } from '@gogame/components';
import { withFormField } from '@gogame/form';

import MixedTypesItem from './MixedTypesItem';

const EMPTY_ARRAY = [];

const BreakdownMixedTypes = withFormField()(
  ({ value = EMPTY_ARRAY, onChange, colorGetter, padding }) => {
    const selected = useMemo(() => {
      return value.map(({ type, label }, i) => {
        return {
          name: `Top ${i + 1}`,
          value: type,
          color: colorGetter(i),
          label: label,
          onSelect: (v) => {
            onChange({}, [
              ...value.slice(0, i),
              { ...value[i], type: v },
              ...value.slice(i + 1),
            ]);
          },
          onToggle: (v) => {
            onChange({}, [
              ...value.slice(0, i),
              { ...value[i], label: v },
              ...value.slice(i + 1),
            ]);
          },
        };
      });
    }, [value, onChange]);

    return (
      <LegacyTextList
        ellipsis={true}
        gutter={0}
        padding={padding}
        limit={100}
        count={selected.length}
        data={selected}
        item={MixedTypesItem}
      />
    );
  }
);

export default BreakdownMixedTypes;
